import { auth } from 'constants/fireabaseConfig'

import { Configuration, DefaultApi } from 'api-client'

export const getAPI = async () => {
  const { currentUser } = auth
  
  // Validate currentUser exists
  if (!currentUser) {
    window.location.reload()
    return null
  }

  try {
    const token = await currentUser.getIdToken(true)
    // Validate token exists
    if (!token) {
      window.location.reload()
      return null
    }
    
    const conf = new Configuration({
      basePath: process.env.REACT_APP_API_BASE_PATH,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })

    return new DefaultApi(conf)
  } catch (error) {
    // Token error - reload page
    window.location.reload()
    return null
  }
}
